import React, { useEffect, useState } from "react";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useDispatch, useSelector } from "react-redux";
import parse from 'html-react-parser'
const _ = require('lodash');

export default function AppShortcut() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { countcv } = useSelector((state) => state.save);
    const MyRole = JSON.parse(user && user.data.roles ? user.data.roles : '{}')
    let listMenus = [
        // { title: 'Bảng tin', icon: 'flaticon-dashboard', link: '/bang-tin' },
        { title: 'Tờ trình', icon: 'totrinh.png', link: '/workflow_walking' },
        { title: 'Đăng ký chấm công', icon: 'dangkycc.png', link: '/list-users-break' },
        { title: 'Giải trình chấm công', icon: 'giaitrinh.png', link: '/list-giaitrinh' },
        { title: 'Duyệt đăng ký chấm công', icon: 'checklist.png', link: '/list-approve-break' },
        { title: 'Duyệt giải trình công', icon: 'assessment.png', link: '/list-duyet-giai-trinh' },
    ]

    const checkRole = (idparent, menu) => {
        let isrole = false;
        let id = menu.id;
        if (!id) id = _.trimStart(menu.link, ' /');
        if (id) {
            if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(id) && MyRole[idparent].children[id].checked === true) isrole = true
            else if (MyRole.hasOwnProperty(id) && MyRole[id].checked === true) isrole = true
        } else {
            if (menu.hasOwnProperty('children') && menu.children && menu.children.length > 0) {
                menu.children.map((sub) => {
                    let idsub = _.trimStart(sub.link, ' /');
                    if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(idsub) && MyRole[idparent].children[idsub].checked === true) isrole = true
                    else if (idsub && MyRole.hasOwnProperty(idsub) && MyRole[idsub].checked === true) isrole = true
                    return sub;
                })
            }
        }
        return isrole
    }
    return (<div className="list-menu">
        {listMenus.map((item, i) => {
            if (checkRole(null, item) || item.role) {
                let title = item.title
                item.id = i + 1
                let DKchoDuyet = countcv && countcv.DKchoDuyet ? countcv.DKchoDuyet : 0
                let GTchuaGui = countcv && countcv.GTchuaGui ? countcv.GTchuaGui : 0
                let DKchuaDuyet = countcv && countcv.DKchuaDuyet ? countcv.DKchuaDuyet : 0
                let GTchuaDuyet = countcv && countcv.GTchuaDuyet ? countcv.GTchuaDuyet : 0
                let workflow_waiting = countcv && countcv.workflow_waiting ? countcv.workflow_waiting : []
                title = <span>{parse(title)}</span>
                if (item.link == '/list-users-break' && DKchoDuyet > 0) {
                    title = <><span>{parse(item.title)}</span><span className="sub-sp">{DKchoDuyet}</span></>
                }
                if (item.link == '/list-giaitrinh' && GTchuaGui > 0) {
                    title = <><span>{parse(item.title)}</span><span className="sub-sp">{GTchuaGui}</span></>
                }
                if (item.link == '/list-approve-break' && DKchuaDuyet > 0) {
                    title = <><span>{parse(item.title)}</span><span className="sub-sp">{DKchuaDuyet}</span></>
                }
                if (item.link == '/list-duyet-giai-trinh' && GTchuaDuyet > 0) {
                    title = <><span>{parse(item.title)}</span><span className="sub-sp">{GTchuaDuyet}</span></>
                }
       
                if (item.link == '/workflow_walking' && (workflow_waiting.length) > 0) {
                    title = <><span>{parse(item.title)}</span><span className="sub-sp">{workflow_waiting.length}</span></>
                }

                return <div key={i} className={`sidebar-menu-item`} >
                    <div to={item.link} className={`nav-link`}>
                        <div className="w-100 d-flex justify-content-center align-items-center">
                            <a href={item.link} className="icon">
                                <img
                                    src={require(`../assets/img/icon-mybhs/${item.icon}`)}
                                    alt={item.title}
                                    className="sidebar-icon"
                                />
                            </a>
                        </div>
                        <p>{title}</p>
                    </div>
                </div>
            } else return null
        })}
    </div>)
}